import React from 'react';
import { cn } from '../../lib/utils';
import { Button } from '../ui/button';

/** Structural icon type — compatible with any lucide-react version. */
type IconComponent = React.ComponentType<{ size?: number | string; strokeWidth?: number | string; className?: string }>;

interface EmptyStateProps {
  icon?: IconComponent;
  title: string;
  body?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
  /** Render the title / body as another element or component (e.g. a dialog's title/description). */
  titleAs?: React.ElementType;
  bodyAs?: React.ElementType;
}

export function EmptyState({ icon: Icon, title, body, action, className, titleAs: Title = 'p', bodyAs: Body = 'p' }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3 py-16 text-center', className)}>
      {Icon && (
        <div className="flex size-12 items-center justify-center rounded-full bg-muted text-muted-foreground">
          <Icon size={22} strokeWidth={1.5} />
        </div>
      )}
      <div className="space-y-1">
        <Title className="text-body-sm-semibold text-foreground">{title}</Title>
        {body && <Body className="max-w-xs text-body-sm-regular text-muted-foreground">{body}</Body>}
      </div>
      {action && (
        <Button variant="outline" size="sm" onClick={action.onClick} className="mt-1">
          {action.label}
        </Button>
      )}
    </div>
  );
}
